export default {
  root: {
    "@media screen and (max-width: 600px)": {
      width: "auto",
    },
  },
};
